<template>

    <div>
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>订单列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card shadow="hover"  class="searchCard" >
            <span class="label-span">
                <label class="label">订单时间段</label>
                <el-date-picker style="width:340px"
                                v-model="query.timeRange"
                                type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                :picker-options="pickerOptions1"
                                class="mr10"
                                :default-time="['00:00:00','23:59:59']">
                </el-date-picker>
            </span>
            <span class="label-span">
                <label class="label">系统单号</label>
                <el-input v-model.trim="query.orderNo" placeholder="系统单号"  class="handle-input mr10"></el-input>
            </span>
            <span class="label-span">
                    <label class="label">推送状态</label>
                    <el-select v-model="query.qyPush"  placeholder="推送状态" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />
                        <el-option v-for="item in Object.keys(pushStatus)" :key="item" :label="pushStatus[item].tagName" :value="item" />
                    </el-select>
                </span>
            <span class="label-span">
                    <label class="label">产品名称</label>
                    <el-select v-model="query.goodsCode"   placeholder="系统产品名称" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />
                        <el-option v-for="item in select4.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </span>
            <span class="label-span">
                    <label class="label">产品编码</label>
                    <el-input v-model.trim="query.goodsCode2" placeholder="请输入产品编码" class="handle-input mr10"></el-input>
                </span>
            <span class="label-span">
                    <label class="label">用户号码</label>
                    <el-input v-model.trim="query.phone" placeholder="请输入用户号码" class="handle-input mr10"></el-input>
                </span>
            <span class="label-span">
                    <label class="label">上游资源</label>
                    <el-select v-model="query.cid"   placeholder="资源名称" filterable  clearable class="handle-select mr10" multiple>
                        <el-option value="" label="全部"  />
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </span>
            <span class="label-span">
                    <label class="label">下游渠道</label>
                    <el-select v-model="query.mids"   placeholder="下游渠道" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />
                        <el-option v-for="item in select3.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </span>

            <el-button type="primary" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" class="mr10"  @click="refreshSearch">重置</el-button>
            <el-button type="primary" icon="el-icon-download" class="mr10" @click="downExcel">导出</el-button>
            <el-button type="success" class="mr10" @click="qyOrderPush">勾选推送</el-button>
            <el-button type="success" class="mr10" @click="qyPushEdit">投放信息修改</el-button>

        </el-card>
        <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" height="600px" border class="table" ref="multipleTable" header-cell-class-name="table-header"
                      v-loading="loading"  element-loading-text="" element-loading-spinner="el-icon-loading"  @selection-change="handleSelectionChange">

                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="orderNo" min-width="160" align="left" label="系统单号">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.orderNo" type="primary" style="font-size:12px;"  @click="copyLink(scope.row.orderNo,'系统单号')">{{scope.row.orderNo}}</el-link> <br>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" align="left" min-width="110" label="用户号码">
                    <template slot-scope="scope" >
                        <el-link type="primary" @click="copyLink(scope.row.phone,'用户号码')" >{{scope.row.phone}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="qyId" min-width="200"  align="left" label="权益方信息">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:18px;">
                            权益方编码：<el-link type="primary" style="font-size:12px;" @click="copyLink(scope.row.qyCode,'权益方编码')">{{scope.row.qyCode}}</el-link> <br>
                            权益方名称：<el-link type="primary" style="font-size:12px;display:inline;line-height:18px;"  @click="copyLink(scope.row.qyName,'权益方名称')">{{scope.row.qyName}}</el-link>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="qyPush" align="left" min-width="90" label="推送状态">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:20px;">
                            <!-- 0:待推送，1：推送失败，2:推送成功，-1：推送异常，9：不推送 -->
                            <el-tag :type="pushStatus[scope.row.qyPush].tagType"><b>{{pushStatus[scope.row.qyPush].tagName}}</b></el-tag>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="goodsName" align="left" min-width="180" label="渠道信息">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:18px;">
                            上游资源：<span @click="copyLink(scope.row.cname,'上游资源')">{{scope.row.cname}}</span>
                            <br>
                            下游渠道：<span @click="copyLink(scope.row.loginName,'下游渠道')">{{scope.row.loginName}}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="goodsName" min-width="280" align="left" label="产品信息">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:18px;">
                            产品编码：<el-link type="primary" style="font-size:12px;" @click="copyLink(scope.row.goodsCode,'产品编码')">{{scope.row.goodsCode}}</el-link> <br>
                            产品名称：<el-link type="primary" style="font-size:12px;display:inline;line-height:18px;"  @click="copyLink(scope.row.goodsName,'产品名称')">{{scope.row.goodsName}}</el-link>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="status" align="left" min-width="90" label="订单状态">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:20px;">
                            <el-tag :type="scope.row.status==9?'success':scope.row.status==-1?'danger':scope.row.status==-2?'danger':scope.row.status==-3 ?'danger':scope.row.status==8?'warning':scope.row.status==5 || scope.row.status==6 ?'primary':'info'"><b>{{formatStatus(scope.row.status) }}</b></el-tag>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime"  align="left" width="150" label="订单创建时间"></el-table-column>
                <el-table-column label="操作" min-width="110" align="center" fixed="right">
                    <template slot-scope="scope">
                        <span class='tableOperBtn' @click="handleDetail(scope.row)"><i class='el-icon-lx-attention'></i> 用户信息</span><br>
                        <span class='tableOperBtn' @click="handleStep(scope.row)"><i class='el-icon-lx-attention'></i> 推送记录</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50, 100, 200,500,1000,2000]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-card>
        <el-dialog title="推送记录" :visible.sync="stepVisible" :modal-append-to-body='false' top="50px" width="1050px">
            <div style="margin-top:-10px;height:35px;color:#666;font-size:16px;margin-left:15px;height:500px;overflow-y:scroll">
                当前订单号: <span style="color:#333;font-weight:700;margin-right:30px">{{form5.orderNo}}
                    </span>
                当前订单状态:
                <el-tag style="font-size:16px;" :type="form.status==9?'success':form5.status==-1?'danger':form5.status==8?'warning':'info'">{{form5.status==0?"校验失败":form5.status==1?"校验成功":form5.status==2?"短信失败":form5.status==3?"短信成功":
                    form5.status==4?"回填失败":form5.status==5?"回填成功":form5.status==-1?"订购失败":form5.status==9?"订购成功":form5.status==8?"回调超时":"其它"}}</el-tag>
                <el-table :data="form4" border class="table"  ref="multipleTable" header-cell-class-name="table-header" >
                    <el-table-column prop="step" width="60" align="center" label="序号">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="step" width="140" align="left" label="执行步骤">
                        <template slot-scope="scope">
                            {{scope.row.step==1?"用户校验-订单创建":scope.row.step==2?"用户校验-系统校验":scope.row.step==3?"用户校验-接口调用":scope.row.step==4?"短信发送-接口调用":
                            scope.row.step==5?"短信回填-系统校验":scope.row.step==6?"短信回填-接口调用":scope.row.step==7?"订购结果-上游回调":
                                scope.row.step==0?"系统订单-订单破解":scope.row.step==8?"订购结果-主动查询":scope.row.step==9?"订购结果-回调超时":scope.row.step==10?"订购结果-回调确认":
                                    scope.row.step==11?"订购结果-查询确认":scope.row.step==12?"订单扣量-扣量计算":scope.row.step==13?"订购结果-下游推送":scope.row.step==14?"订单限量-到量计算":
                                        scope.row.step==15?"退订导入-变更状态":scope.row.step==16?"用户退订-下游推送":scope.row.step==17?"权益同步-订单推送":""}}</template>
                    </el-table-column>
                    <el-table-column prop="stepStatus" width="85" align="center" label="执行结果">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.stepStatus==1?'success':scope.row.stepStatus==0?'warning':scope.row.stepStatus==-1?'danger':''">
                                {{scope.row.stepStatus==1?"执行成功":scope.row.stepStatus==0?"执行失败":scope.row.stepStatus==-1?"执行异常":""}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stepStatus" width="85" align="center" label="执行方式">
                        <template slot-scope="scope">
                            <span>{{scope.row.operType==1?'系统执行':scope.row.operType==2?'系统轮询':scope.row.operType==3?'人工操作':"-"}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stepStatus" min-width="120" align="left" label="下游请求信息">
                        <template slot-scope="scope">
                            <p v-if="scope.row.param!=null && scope.row.param!=''">
                                <el-popover placement="bottom" title="详细信息"  width="600" trigger="hover" :content="scope.row.param">
                                    <span style="background:none;color:blue;border:none;font-size:12px;" slot="reference" >{{scope.row.param.length>20?scope.row.param.substr(0,18)+'...':scope.row.param}}</span>
                                </el-popover>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stepStatus" min-width="120" align="left" label="系统返回信息">
                        <template slot-scope="scope">
                            <p v-if="scope.row.info!=null && scope.row.info!=''">
                                <el-popover placement="bottom" title="详细信息"  width="600" trigger="click" :content="scope.row.info">
                                    <span style="background:none;color:blue;border:none;font-size:12px;" slot="reference" >{{scope.row.info.length>20?scope.row.info.substr(0,18)+'...':scope.row.info}}</span>
                                </el-popover>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" width="160" align="center"  label="执行时间"></el-table-column>
                </el-table>
            </div>
            <div style="clear:both"></div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="用户信息" :visible.sync="detailVisible" :modal-append-to-body='false' top="50px" width="500px">
            <p class="label-span">
                <label class="label">手机号码</label>
                <span style="margin-left:15px">{{form3.phone}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">验证码</label>
                <span style="margin-left:15px">{{form3.sms}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">号码归属地</label>
                <span style="margin-left:15px">{{form2.area}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">号码运营商</label>
                <span style="margin-left:15px">{{form2.isp==1?"移动":form2.isp==2?"联通":form2.isp==3?"电信":form2.isp==4?"广电":""}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">落地页链接</label>
                <el-link @click="copyLink(form2.link,'落地页链接')" type="success" style="margin-left:15px">{{form2.link}}</el-link>
            </p> <br>
            <p class="label-span">
                <label class="label">投放平台</label>
                <span style="margin-left:15px">{{form2.platform}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">用户触点</label>
                <span style="margin-left:15px">{{form2.contact}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">用户IP</label>
                <span style="margin-left:15px">{{form2.userIp}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">APP包名(英文)</label>
                <span style="margin-left:15px">{{form2.appPackage}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">浏览器标识</label>
                <span style="margin-left:15px;color:#999;font-size:12px">{{form2.ua}}</span>
            </p> <br>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="投放信息修改" :visible.sync="contactVisible" :modal-append-to-body='false' top="50px" width="450px">
            <el-form ref="form1" :model="form1" :rules="form1Rules"  label-width="120px" @submit.native.prevent="saveForm">
                <el-form-item label="投放平台" prop="platform" >
                    <el-select v-model="form1.platform" filterable allow-create default-first-option placeholder="请选择投放平台"
                               style="width:220px;">
                        <el-option v-for="item in platformOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户触点" prop="contact" >
                    <el-select v-model="form1.contact" filterable allow-create default-first-option placeholder="请选择用户触点"
                    @change="contactChange" style="width:220px;">
                        <el-option v-for="item in Object.keys(contactOptions)" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="APP包名(英文)" prop="appPackage" >
                    <el-input v-model.trim="form1.appPackage" placeholder="请输入APP包名" style="width:220px;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="contactCancel('form1')">取 消</el-button>
                <el-button type="primary" @click="saveForm('form1')">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    fetchQyData,
    downQyOrderExcel,
    getOrderDetail,
    getChildOrder, getQyOrderStep, updateContact
} from '../../api/comOrder';
import { qyPush } from '../../api/comOrderPush';
import {fetchSelect as fetchSelect6} from '../channel/channel';  //资源名称
import {fetchSelect as fetchSelect3} from '../../api/member';  //下游渠道
import {fetchSelect2 as fetchSelect4} from '../../api/comGoods';  //产品
import JsonViewer from 'vue-json-viewer';
import { formatStatus } from '@/utils/filters';
import vContent1 from '../../components/page/Dashboard1.vue';
export default {
    name:'comOrder',
    data() {
        return {
            pushStatus:{
                "-1": {tagName:"推送异常",tagType:"danger"},
                "0": {tagName:"待推送",tagType:"info"},
                "1": {tagName:"推送失败",tagType:"warning"},
                "2": {tagName:"推送成功",tagType:"success"},
                // "9": {tagName:"不推送",tagType:"info"},
            },
            platformOptions:["巨量引擎"],
            contactOptions:{
                "今日头条":"com.ss.android.article.news",
                "今日资讯":"com.hnjm.news",
                "番茄畅听":"lite.xing.yerongxkx",
                "懂车帝":"com.ss.android.auto"
            },
            select3:{ option:'',  },
            select4:{ option:'',  },
            select6:{ option:'',  },
            query: {
                isPj: "0",
                pageIndex: 1,
                pageSize: 10,
            },
            tableData: [],
            multipleSelection: [],
            detailVisible:false,
            contactVisible:false,
            stepVisible:false,
            loading:false,
            row:{},
            pageTotal: 0,
            form: {
            },
            form1: {
            },
            form2: {  },
            form3: {  phone:'',sms:''  },
            form4: {   },
            form5: {   },
            form1Rules: {
                platform: [
                    { required: true, message: '请选择投放平台', trigger: 'change' }
                ],
                contact: [
                    { required: true, message: '请选择用户触点', trigger: 'change' }
                ],
                appPackage: [
                    { required: true, message: '请输入APP包名', trigger: 'blur' },
                ],
            },
            pickerOptions1: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        var nowDate = new Date();
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        const dayDate2 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', [dayDate1, dayDate2]);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        const dayDate2 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', [dayDate1, dayDate2]);

                    }
                },{
                    text: '2天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 48);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        const dayDate2 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', [dayDate1, dayDate2]);
                    }
                }]
            }
        };
    },
    components: {
        vContent1 ,
        JsonViewer
    },
    created() {
        var nowDate = new Date();
        var date = {
            year: nowDate.getFullYear(),
            month: nowDate.getMonth(),
            day: nowDate.getDate()
        };
        if(date.month==0){
            date.month = 12;
            date.year =  date.year - 1;
        }else{
            date.month = date.month +1;
        }
        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
        const dayDate2 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
        this.$set(this.query, "timeRange", [dayDate1, dayDate2]);
    },
    //页面加载方法
    mounted: function () {
        //查询列表
        this.getSelect3();
        this.getSelect4();
        this.getSelect6();
        this.handleSearch();
    },
    beforeDestroy() {
        // 离开前保存 query 到本地
        localStorage.setItem('comOrderQuery', JSON.stringify(this.query));
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },

    methods: {
        downFile(url,name) {
            let fileUrl = url  //服务器文件地址
            this.getBlob(fileUrl).then(blob => {
                this.saveAs(blob, name)
            })
        },
        //通过文件下载url拿到对应的blob对象
        getBlob(url) {
            return new Promise(resolve => {
                const xhr = new XMLHttpRequest()
                xhr.open('GET', url, true)
                xhr.responseType = 'blob'
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        resolve(xhr.response)
                    }
                }

                xhr.send()
            })
        },
        //下载文件
        saveAs(blob, filename) {
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.click()
        },
        handleBeforeUnload(event) {
            // 在这里执行页面关闭前的操作
            localStorage.removeItem('comOrderQuery');
        },
        formatStatus,
        load(tree, treeNode, resolve) {
            let data = {};
            data.pid = tree.id;
            getChildOrder(data).then(res => {
                if(res.code=='200'){
                    if(res.data==null || res.data.length==0){
                        this.$message("暂无子订单");
                        resolve([]);
                    }else{
                        resolve(res.data);
                    }

                }else{
                    this.$message(res.message);
                    resolve([]);
                }
            });
        },
        // 触发搜索按钮
        handleSearch() {
            if(this.query.timeRange){
                this.query.startTime = this.query.timeRange[0];
                this.query.endTime = this.query.timeRange[1];
            } else{
                this.query.startTime = '';
                this.query.endTime = '';
            }

            if(this.query.cid){
                this.query.cid2 = this.query.cid.filter(tag => tag !== '').join(',');
                if(this.query.cid2.charAt(0) === ','){
                    this.query.cid2 = this.query.cid2.substring(1);
                }
            }else{
                this.query.cid2 = '';
            }
            if(this.query.phone!=null && this.query.phone!=undefined && this.query.phone!=''){
                if(this.query.phone.length!=11){
                    this.$message({
                        message: '用户号码必须为11位',
                        type: 'warning'
                    });
                    return;
                }
            }
            if(this.query.goodsCode2!=null && this.query.goodsCode2!=undefined && this.query.goodsCode2!=''){
                if(this.query.goodsCode2.length!=12){
                    this.$message({
                        message: '产品编码必须为12位',
                        type: 'warning'
                    });
                    return;
                }
            }
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){
            this.$set(this.query, 'startTime');
            this.$set(this.query, 'endTime');
            this.$set(this.query, 'orderNo');
            this.$set(this.query, 'goodsCode');
            this.$set(this.query, 'goodsCode2');
            this.$set(this.query, 'phone');
            this.$set(this.query, 'cid');
            this.$set(this.query, 'mids');
            this.handleSearch();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handlePush2(row){
            qyPush(row).then(res => {
                if(res.code=='200'){
                    this.$notify({ title: '成功', message: row.orderNo+'推送执行成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message:  row.orderNo+'推送执行失败：'+res.message,duration: 5000, type: 'error' });
                }
            });
        },

        //触发刷新按钮
        refresh(){
            history.go(0);

        },
        contactChange(){
            this.$set(this.form1, 'appPackage', this.contactOptions[this.form1.contact]);
        },
        contactCancel(formName){
            this.loading = false;
            this.contactVisible = false
            this.$refs[formName].resetFields();
        },
        saveForm(formName){
            var _this = this;
            this.$refs[formName].validate((valid) => {
                if (!valid){
                    return false;
                }
                _this.loading = true;
                let errorOeder = [];
                // 将每个setTimeout包装为Promise
                const promises = this.multipleSelection.map((element, i) => {
                    let orderNo = element.orderNo;
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            let param = {
                                ..._this.form1,
                                orderNo
                            }
                            // 假设updateContact返回Promise
                            updateContact(param)
                                .then(() => {
                                    resolve(); // 操作成功完成
                                })
                                .catch(error => {
                                    errorOeder.push(orderNo);
                                    resolve(); // 操作成功完成
                                });
                        }, 350 * i);
                    });
                });

                // 等待所有Promise完成
                Promise.all(promises).then(() => {
                    // 所有updateContact执行完成后执行回调
                    if (errorOeder.length<1){
                        this.$message("修改成功");
                        _this.contactCancel(formName);
                        _this.getData();
                        return;
                    }
                    const h = this.$createElement;
                    let html = [
                        h('p', null, '投放信息修改完成,共修改'+ this.multipleSelection.length + '条订单'),
                        h('p', null, '其中'+errorOeder.length+"条订单修改失败：")
                    ];
                    for(let order of errorOeder){
                        html.push(h('p', { style: 'color: teal' }, order));
                    }
                    _this.$msgbox({
                        title: '提示',
                        message: h('p', null, html),
                        confirmButtonText: '确定',
                        beforeClose: (action, instance, done) => {
                            _this.contactCancel(formName);
                            done();
                            _this.getData();
                        }
                    })
                });
            });
        },
        qyPushEdit(){
            const length = this.multipleSelection.length;
            if(length===0){
                this.$message.error("请勾选要修改的订单");
                return;
            }
            this.contactVisible = true;
        },
        qyOrderPush(){
            const length = this.multipleSelection.length;
            if(length===0){
                this.$message.error("请勾选要执行推送的订单");
                return;
            }
            var that = this;
            that.$confirm('确认执行批量推送吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.loading = true;
                setTimeout(() => {
                    if(this.loading){
                        this.loading = false;
                        this.getData();
                        this.$message("等待后台执行...");
                    }
                }, 5000);
                for (let i = 0; i < length; i++) {
                    setTimeout(() => {
                        that.handlePush2(that.multipleSelection[i]);
                        if(i==length-1){
                            setTimeout(() => {
                                this.loading = false;
                                this.getData();
                            }, 1500);
                        }
                    }, 350*i);

                }
            });
        },
        downExcel(){
            var that = this;
            that.$confirm('确认要导出吗？', '提示', {
                type: 'warning'
            }).then(() => {
                setTimeout(() => {
                    if(that.loading){ return; }
                    that.loading = false;
                    that.getData();
                }, 7000)
                if(that.query.timeRange!=null && that.query.timeRange!=undefined && that.query.timeRange!=''){
                    that.query.startTime = that.query.timeRange[0];
                    that.query.endTime = that.query.timeRange[1];
                }
                if(that.query.phone!=null && that.query.phone!=undefined && that.query.phone!=''){
                    if(that.query.phone.length!=11){
                        that.$message({
                            message: '用户号码必须为11位',
                            type: 'warning'
                        });
                        return;
                    }
                }
                that.loading = true
                downQyOrderExcel(that.query).then(res => {
                    that.loading = false
                    if (res.code == '200') {
                        that.$notify({ title: '成功', message: res.message, duration: 5000, type: 'success' });
                    } else {
                        that.$notify({ title: '失败', message: '后台下载异常', duration: 5000, type: 'error' });
                    }
                });
            });
        },
        //获取下拉框数据
        getSelect3(){
            this.select3 = {};
            fetchSelect3(this.select3).then(res => {
                if(res.code=='200'){
                    this.$set(this.select3, 'option', res.data);
                }
            });
        },
        getSelect4(){
            this.select4 = {};
            fetchSelect4(this.select4).then(res => {
                if(res.code=='200'){
                    this.$set(this.select4, 'option', res.data);
                }
            });
        },
        getSelect6(){
            this.select6 = {};
            fetchSelect6(this.select6).then(res => {
                if(res.code=='200'){
                    this.$set(this.select6, 'option', res.data);
                }
            });
        },
        //查询
        getData(){
            this.loading = true;
            fetchQyData(this.query).then(res => {
                this.loading = false;
                if(res.code=='200'){
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;
                }else{
                    this.tableData = [];
                    this.pageTotal = 0;
                }
            });
        },

        copyLink(text,name){
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);
            //提示已复制
            this.$message.success(name+"复制成功");
        },
        //详情
        handleDetail( row){
            getOrderDetail(row).then(res => {
                if(res.code=='200'){
                    if(res.data==null){
                        this.$message.error("暂无数据");
                        return;
                    }
                    this.detailVisible = true;
                    this.form2 = res.data;
                    this.form3.phone = row.phone;
                    this.form3.sms = row.sms;
                }else{
                    this.$message.error(res.message);
                }
            });
        },

        handleStep( row){
            getQyOrderStep(row).then(res => {
                if(res.code=='200'){
                    this.stepVisible = true;
                    this.form4 = res.data.comOrderStepList;
                    this.form5 = row;
                }else{
                    this.$message.error(res.message);
                }
            });
        },

        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
    }
};
</script>
<style>
.el-drawer__open .el-drawer.ttb {
    height:100% !important;
}
</style>
<style scoped>

:v-deep .el-icon-arrow-right:before {
    color: #1890ff;

    font-size: 20px;

    font-weight: 700px;
}

::v-deep .el-table__expand-icon .el-icon-arrow-right:before {

    font-size:15px;
    color:#409EFF;
    text-align: center;
}
::v-deep .el-table__expand-icon--expanded .el-icon-arrow-right:before{
    font-size:15px;
    color:#999;
    text-align: center;
}


.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 190px;
    display: inline-block;
}

.handle-input {
    width: 190px;
    display: inline-block;
}
.handle-del {
    float:right;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table__row--level-1{
    background-color: #efefef !important;
}
.el-table__row--level-1:hover{
    background-color: #efefef !important;
}
.el-table__row--level-1::after{
    background-color: #efefef !important;
}
.el-table--small .el-table__cell{
    padding:3px 2px;
}
.el-table .cell{
    padding:3px 2px;
}
.white-space-pre-line {
    white-space: pre-line; /* 保留换行符，自动合并空格 */
}
</style>
